import type { Template } from "@/types";

export const PO_07_H7_V0: Template[] = [
{
    id: "po-07-h7v0-01",
    name: "PO 01 - H7V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h7_v0_01.png",
    size: [1217, 851],
    style: {},
        slots: [        
            { id: "1", x: 41, y: 242, width: 260, height: 180, rotation: 0, imageRotation: 0 },
            { id: "2", x: 41, y: 430, width: 260, height: 180, rotation: 0, imageRotation: 0 },
            { id: "3", x: 309, y: 242, width: 260, height: 180, rotation: 0, imageRotation: 0 },
            { id: "4", x: 309, y: 430, width: 260, height: 180, rotation: 0, imageRotation: 0 },
            { id: "5", x: 670, y: 180, width: 481, height: 323, rotation: 0, imageRotation: 0 },
            { id: "6", x: 670, y: 510, width: 237, height: 160, rotation: 0, imageRotation: 0 },
            { id: "7", x: 915, y: 510, width: 236, height: 160, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-07-h7v0-02",
    name: "PO 02 - H7V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h7_v0_02.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 62, y: 257, width: 484, height: 336, rotation: 0, imageRotation: 0 },
            { id: "2", x: 671, y: 172, width: 238, height: 164, rotation: 0, imageRotation: 0 },
            { id: "3", x: 671, y: 344, width: 238, height: 164, rotation: 0, imageRotation: 0 },
            { id: "4", x: 671, y: 517, width: 238, height: 163, rotation: 0, imageRotation: 0 },
            { id: "5", x: 917, y: 172, width: 238, height: 164, rotation: 0, imageRotation: 0 },
            { id: "6", x: 917, y: 344, width: 238, height: 164, rotation: 0, imageRotation: 0 },
            { id: "7", x: 917, y: 517, width: 238, height: 163, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h7v0-03",
    name: "PO 03 - H7V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h7_v0_03.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 45, y: 182, width: 520, height: 360, rotation: 0, imageRotation: 0 },    
        { id: "2", x: 45, y: 550, width: 168, height: 120, rotation: 0, imageRotation: 0 },
        { id: "3", x: 221, y: 550, width: 168, height: 120, rotation: 0, imageRotation: 0 },
        { id: "4", x: 397, y: 550, width: 168, height: 120, rotation: 0, imageRotation: 0 },
        { id: "5", x: 653, y: 154, width: 519, height: 351, rotation: 0, imageRotation: 0 },
        { id: "6", x: 653, y: 513, width: 256, height: 184, rotation: 0, imageRotation: 0 },
        { id: "7", x: 917, y: 513, width: 255, height: 184, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h7v0-04",
    name: "PO 04 - H7V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h7_v0_04.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 39, y: 242, width: 531, height: 368, rotation: 0, imageRotation: 0 },
        { id: "2", x: 647, y: 241, width: 173, height: 118, rotation: 0, imageRotation: 0 },
        { id: "3", x: 828, y: 241, width: 172, height: 118, rotation: 0, imageRotation: 0 },     
        { id: "4", x: 647, y: 367, width: 173, height: 118, rotation: 0, imageRotation: 0 },
        { id: "5", x: 647, y: 493, width: 173, height: 118, rotation: 0, imageRotation: 0 },
        { id: "6", x: 828, y: 367, width: 352, height: 244, rotation: 0, imageRotation: 0 },
        { id: "7", x: 1008, y: 241, width: 172, height: 118, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h7v0-05",
    name: "PO 05 - H7V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h7_v0_05.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 69, y: 163, width: 537, height: 363, rotation: 0, imageRotation: 0 },
        { id: "2", x: 614, y: 163, width: 536, height: 363, rotation: 0, imageRotation: 0 },
        { id: "3", x: 69, y: 534, width: 210, height: 151, rotation: 0, imageRotation: 0 },
        { id: "4", x: 287, y: 534, width: 210, height: 151, rotation: 0, imageRotation: 0 },
        { id: "5", x: 505, y: 534, width: 210, height: 151, rotation: 0, imageRotation: 0 },
        { id: "6", x: 723, y: 534, width: 210, height: 151, rotation: 0, imageRotation: 0 },
        { id: "7", x: 941, y: 534, width: 209, height: 151, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h7v0-06",
    name: "PO 06 - H7V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h7_v0_06.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 52, y: 195, width: 273, height: 193, rotation: 0, imageRotation: 0 },
        { id: "2", x: 333, y: 195, width: 273, height: 193, rotation: 0, imageRotation: 0 },
        { id: "3", x: 614, y: 195, width: 272, height: 193, rotation: 0, imageRotation: 0 },
        { id: "4", x: 894, y: 195, width: 272, height: 193, rotation: 0, imageRotation: 0 },
        { id: "5", x: 52, y: 396, width: 366, height: 259, rotation: 0, imageRotation: 0 },
        { id: "6", x: 426, y: 396, width: 366, height: 259, rotation: 0, imageRotation: 0 },
        { id: "7", x: 800, y: 396, width: 365, height: 259, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h7v0-07",
    name: "PO 07 - H7V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h7_v0_07.png",
    size: [1217, 851],
    style: {},
    slots: [      
        { id: "1", x: 0, y: 204, width: 197, height: 143, rotation: 0, imageRotation: 0 },
        { id: "2", x: 0, y: 355, width: 197, height: 142, rotation: 0, imageRotation: 0 },
        { id: "3", x: 0, y: 505, width: 197, height: 142, rotation: 0, imageRotation: 0 },
        { id: "4", x: 205, y: 505, width: 196, height: 142, rotation: 0, imageRotation: 0 },
        { id: "5", x: 409, y: 505, width: 196, height: 142, rotation: 0, imageRotation: 0 },
        { id: "6", x: 205, y: 204, width: 400, height: 293, rotation: 0, imageRotation: 0 },
        { id: "7", x: 613, y: 204, width: 604, height: 443, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h7v0-08",
    name: "PO 08 - H7V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h7_v0_08.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 0, y: 204, width: 605, height: 443, rotation: 0, imageRotation: 0 },
        { id: "2", x: 613, y: 204, width: 196, height: 143, rotation: 0, imageRotation: 0 },
        { id: "3", x: 613, y: 355, width: 196, height: 142, rotation: 0, imageRotation: 0 },
        { id: "4", x: 613, y: 505, width: 196, height: 142, rotation: 0, imageRotation: 0 },
        { id: "5", x: 817, y: 505, width: 196, height: 142, rotation: 0, imageRotation: 0 },
        { id: "6", x: 1021, y: 505, width: 196, height: 142, rotation: 0, imageRotation: 0 },
        { id: "7", x: 817, y: 204, width: 400, height: 293, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h7v0-09",
    name: "PO 09 - H7V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h7_v0_09.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 0, y: 204, width: 605, height: 443, rotation: 0, imageRotation: 0 },
        { id: "2", x: 613, y: 204, width: 196, height: 143, rotation: 0, imageRotation: 0 },
        { id: "3", x: 817, y: 204, width: 196, height: 143, rotation: 0, imageRotation: 0 },
        { id: "4", x: 1021, y: 204, width: 196, height: 143, rotation: 0, imageRotation: 0 },
        { id: "5", x: 1021, y: 355, width: 196, height: 142, rotation: 0, imageRotation: 0 },
        { id: "6", x: 1021, y: 505, width: 196, height: 142, rotation: 0, imageRotation: 0 },
        { id: "7", x: 613, y: 355, width: 400, height: 292, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h7v0-10",
    name: "PO 10 - H7V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h7_v0_10.png",
    size: [1217, 851],
    style: {},
    slots: [    
        { id: "1", x: 47, y: 183, width: 227, height: 156, rotation: 0, imageRotation: 0 },
        { id: "2", x: 47, y: 347, width: 227, height: 156, rotation: 0, imageRotation: 0 },
        { id: "3", x: 47, y: 511, width: 227, height: 156, rotation: 0, imageRotation: 0 },
        { id: "4", x: 282, y: 183, width: 653, height: 484, rotation: 0, imageRotation: 0 },
        { id: "5", x: 943, y: 183, width: 226, height: 156, rotation: 0, imageRotation: 0 },
        { id: "6", x: 943, y: 347, width: 226, height: 156, rotation: 0, imageRotation: 0 },
        { id: "7", x: 943, y: 511, width: 226, height: 156, rotation: 0, imageRotation: 0 }
    ],
}
];